var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserCircle = function SvgUserCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F36805",
    d: "M12 11.055a1.68 1.68 0 1 0 0-3.36 1.68 1.68 0 0 0 0 3.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F36805",
    d: "M12 2.156a9.844 9.844 0 0 0-7.415 16.315c.447.483.94.922 1.47 1.312a9.804 9.804 0 0 0 11.89 0 9.6 9.6 0 0 0 1.458-1.312A9.83 9.83 0 0 0 12 2.156m0 3.57a3.65 3.65 0 1 1-3.648 3.649A3.66 3.66 0 0 1 12 5.726m6.064 11.288c-.21.25-.433.485-.67.722a4.3 4.3 0 0 0-.774-.683 4.5 4.5 0 0 0-2.493-.735H9.874a4.5 4.5 0 0 0-2.494.735 4.3 4.3 0 0 0-.774.683 12 12 0 0 1-.67-.722 9 9 0 0 1-.498-.8q.263-.277.564-.513A6.35 6.35 0 0 1 9.94 14.39h4.187a6.35 6.35 0 0 1 3.937 1.312q.3.236.564.512a9 9 0 0 1-.564.8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserCircle);
export default ForwardRef;